import { render, staticRenderFns } from "./sidebar-menu-global.vue?vue&type=template&id=cadbcbac&scoped=true"
import script from "./sidebar-menu-global.vue?vue&type=script&lang=js"
export * from "./sidebar-menu-global.vue?vue&type=script&lang=js"
import style0 from "./sidebar-menu-global.vue?vue&type=style&index=0&id=cadbcbac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cadbcbac",
  null
  
)

export default component.exports